import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	creatorCardContainer: {
		display             : "grid",
		gridTemplateColumns : props?.listLength < 5 ? "repeat(5, 1fr)" : "repeat(auto-fit, minmax(225px, 1fr))",
		gridGap             : "2.5rem"
	}
} ) );
